
import { configurations } from "@/common/config";


/**
 *	LocalSettings:
 *	Speichern der Users-Einstellung in der lokalen Umgebung.
 *
 * 	chrome.storage 		=>	Storage für Chrome-Plugins
 * 	localStorage		=>	Storage für Browser-Anwendungen
 *
 */

export const state = {
  configKey: '',
  design: {
	darkMode: true,
  }
}

export const mutations = {
  MODIFY (state, overrideSettings = {}) {
	console.log(overrideSettings);
	this.state.localSettings = Object.assign(state, overrideSettings)
  },
}

export const actions = {
  /**
	*	Voreinstellungen aus der localStorage laden.
	*	Wird in der App.vue bei Initialisierung aufgerufen.
	*	this.$store.dispatch('LOAD_SETTINGS').then(() => {...});
	*/
  LOAD () {
	return new Promise((resolve, reject) => {
	  if (  window.chrome && chrome.storage) {
		chrome.storage.sync.get(['settings'], (data) => {
		  this.state.localSettings = Object.assign({}, this.state.localSettings, data.settings)
		  resolve( this.state )
		})
	  } else if (localStorage) {
		var data = localStorage.getItem('settings')
		if (!data || data.substr(0, 1) != '{') data = '{}'
		data = JSON.parse(data)
		this.state.localSettings = Object.assign({}, this.state.localSettings, data)

		resolve( this.state )
	  } else {
		console.log('No LocalStorage available')
		reject()
	  }
	})
  },

  /**
 	*	Voreinstellungen in der localStorage speichern.
	*	Wird nach Klick auf "Speichern" in der Settings.vue aufgerufen.
	*/
  SAVE ({ commit }) {
	return new Promise((resolve, reject) => {

	  if (window.chrome && chrome.storage) {
		chrome.storage.sync.set({ settings: this.state.localSettings }, () => {
		  resolve()
		})
		this.dispatch('localSettings/LOAD')
	  } else if (localStorage) {
		localStorage.setItem('settings', JSON.stringify(this.state.localSettings))
		this.dispatch('localSettings/LOAD')
		resolve()
	  } else {
		console.log('No LocalStorage available')
		reject()
	  }
	})
  },

  /**
	 *	Voreinstellung zurücksetzen.
	 *	URL und picks werden gelöscht – auch in der localStorage!
	 *	this.$store.commit('RESET ');
	 */
  RESET ({ state }) {
	if (window.chrome && chrome.storage) {
	  chrome.storage.sync.clear()
	} else if (localStorage) {
	  localStorage.setItem('settings', null)
	}
	this.commit('localSettings/MODIFY', { picks:[] })
  },

  /**
   * Find configuration for current host.
   * Set switcher to default selection depending
   * on the host.
   * 
   */
  SET_DEFAULT_CONFIGURATION() {
	this.dispatch('localSettings/LOAD').then(() => {
		if (this.state.localSettings.configKey) {
			console.log('Configuration-Key found in localStorage: ' + this.state.localSettings.configKey);
			var confKey = this.state.localSettings.configKey;
		} else {
			var confKey = Object.keys(configurations).shift();
			for (var confName in configurations) {
				var conf = configurations[confName];
				if (window.location.hostname == conf.hostName) {
					confKey = confName;
					break;
				}
			}
			console.log('Configuration-Key not found in localStorage. Using ' + confKey);
		}
		this.commit( 'settings/SET_CONFIG', configurations[confKey] );
		this.commit( 'localSettings/MODIFY', {configKey:confKey} );	
		this.dispatch( 'localSettings/SAVE' );
	});
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
